import type { ReleaseVersion } from 'src/types/ReleaseVersion';
import { api } from './api';
import type { PaginatedListResponse } from './response_models/PaginatedListIResponse';

interface ReleaseVersionListRequestParams {
  page?: number;
  pageSize?: number;
  searchText?: string;
}

export const releaseVersionsApi = api.injectEndpoints({
  endpoints: builder => ({
    getReleaseVersionsList: builder.query<PaginatedListResponse<ReleaseVersion>, ReleaseVersionListRequestParams>({
      query: ({ page, pageSize, searchText }) => ({
        url: `devices/releases/`,
        method: 'GET',
        params: { page, page_size: pageSize, search: searchText },
      }),
    }),
    deleteReleaseVersion: builder.mutation<void, { version_number: string }>({
      query: ({ version_number }) => ({
        url: `devices/releases/${version_number}/`,
        method: 'DELETE',
      }),
    }),
    promoteReleaseVersion: builder.mutation<void, { release_version_id: string }>({
      query: ({ release_version_id }) => ({
        url: `devices/releases/promote/${release_version_id}/`,
        method: 'PATCH',
      }),
    }),
  }),
});

export const { useLazyGetReleaseVersionsListQuery, useDeleteReleaseVersionMutation, usePromoteReleaseVersionMutation } =
  releaseVersionsApi;
